import React from 'react'
import PropTypes from 'prop-types'
import { Modal, RenderedHtml } from 'components'
import { useCommunityText } from 'utils'

const propTypes = {
  onClose: PropTypes.func.isRequired,
}

const defaultProps = {}

function SurveyCompletionModal({ onClose }) {
  const t = useCommunityText()
  const content = t('surveyCompletionModal')
  return (
    <Modal onClose={onClose} className="text-center">
      <RenderedHtml>{content}</RenderedHtml>
    </Modal>
  )
}

SurveyCompletionModal.propTypes = propTypes
SurveyCompletionModal.defaultProps = defaultProps

export default SurveyCompletionModal
